import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Heading from "../components/individuals/Heading";
import FadeInSection, {
  FadeInType,
} from "../components/wrappers/FadeInSection";

const YoungResources = [
  {
    title: "Start With a Book",
    href: "https://www.startwithabook.org/",
    description:
      "To combat the learning loss that many children experience over the summer, Start with a Book offers parents, caregivers, summer program staff and librarians lots of engaging ideas for getting kids hooked on reading, exploring and learning all summer long — and beyond.",
  },
  {
    title: "Code.org",
    href: "https://code.org/",
    description:
      "Code.org® is an education innovation nonprofit dedicated to the vision that every student in every school has the opportunity to learn computer science as part of their core K-12 education.",
  },
  {
    title: "Sciencebuddies",
    href: "https://www.sciencebuddies.org/",
    description: "Sciencebuddies is a free resource for science project ideas.",
  },
  {
    title: "Bil Nye.com",
    href: "https://www.billnye.com/",
    description:
      "The official website of Bill Nye The Science Guy featuring books, shows, appearances, episode guides, and home demos.",
  },
  {
    title: "James Dyson Foundation",
    href: "https://www.jamesdysonfoundation.com/",
    description:
      "The James Dyson Foundation provides the materials and mentorship that budding inventors need, so that they can get hands-on with problems, think differently, and find solutions.",
  },
  {
    title: "Scholastic",
    href: "https://www.scholastic.com/parents/school-success/learn-at-home.html",
    description:
      "Scholastic is a leading provider of literacy curriculum, professional services, and classroom magazines, and a producer of educational and popular children's media",
  },
  {
    title: "Hello Ruby",
    href: "https://www.helloruby.com/",
    description:
      "Hello Ruby is the world’s most whimsical way to learn about technology, computing and coding.",
  },
  {
    title: "Musiclab",
    href: "https://musiclab.chromeexperiments.com/",
    description:
      "Chrome Music Lab is a website that makes learning music more accessible through fun, hands-on experiments.",
  },
  {
    title: "Calacademy",
    href: "https://www.calacademy.org/ ",
    description:
      "The mission of the California Academy of Sciences is to regenerate the natural world through science, learning, and collaboration.",
  },
  {
    title: "NASA",
    href: "https://www.nasa.gov/stem/ ",
    description: "NASA offers unique STEM related opportunities hosted by NASA",
  },
  {
    title: "Scratch MIT",
    href: "https://scratch.mit.edu/ ",
    description:
      "Scratch is a programming language and an online community where children can program and share interactive media such as stories, games, and animation with people from all over the world.",
  },
  {
    title: "Codemonkey",
    href: "https://www.codemonkey.com/",
    description:
      "CodeMonkey is an award winning online platform that teaches kids real coding languages like CoffeeScript and Python.",
  },
];

const OldResources = [
  {
    title: "Congressional App Challenge",
    href: "https://www.congressionalappchallenge.us/",
    description:
      "A nationwide competition that encourages middle and high school students to learn coding and computer science by creating their own apps.",
  },
  {
    title: "Pennsylvania Junior Academy of Sciences",
    href: "https://www.pjas.net/",
    description:
      "A statewide STEM competition where students conduct independent science research projects and present their findings to a panel of judges.",
  },
  {
    title: "ECybermission",
    href: "https://www.ecybermission.com/",
    description:
      "A web-based STEM competition for students in grades 6-9 that encourages teamwork to solve real-world community challenges through scientific inquiry.",
  },
  {
    title: "You Be the Chemist (YBTC)",
    href: "https://www.competitionsciences.org/competitions/you-be-the-chemist-challenge/",
    description:
      "A fun, interactive academic competition that engages students in chemistry concepts and real-world applications.",
  },
  {
    title: "ISEF",
    href: "https://www.societyforscience.org/isef/",
    description:
      "The world's largest pre-college STEM competition, where students showcase their independent research and compete for scholarships and awards.",
  },
  {
    title: "Governor's School of NJ",
    href: "https://www.nj.gov/govschool/",
    description:
      "A summer program offering highly talented high school students a chance to engage in advanced academic and research experiences in STEM and the arts.",
  },
  {
    title: "International Chemistry Olympiad",
    href: "https://www.ichosc.org/",
    description:
      "A prestigious chemistry competition that challenges students to demonstrate their knowledge and problem-solving skills in theoretical and practical chemistry.",
  },
  {
    title: "USA Computing Olympiad (USACO)",
    href: "https://usaco.org/",
    description:
      "A national computer science competition that trains and evaluates students on algorithmic problem-solving and programming skills.",
  },
  {
    title: "Future Business Leaders of America",
    href: "https://www.fbla.org/",
    description:
      "An organization that prepares students for careers in business and leadership through academic competitions, leadership development, and networking opportunities.",
  },
  {
    title: "Model UN",
    href: "https://www.gpyce.org/mun-conference",
    description:
      "An educational simulation where students learn about diplomacy, international relations, and the United Nations by representing countries in debates and negotiations.",
  },
];

export default function Resources() {
  return (
    <div className="w-full h-full">
      <Navbar />
      <section className="pt-[120px] relative z-40">
        <FadeInSection distance={FadeInType.FADEONLY}>
          <Heading heading="Resources" className="text-center text-primary" />
          <div className="relative z-10 mx-auto xl:max-w-1/4 sm:max-w-1/2 max-w-3/4 mb-10">
            <p className="dark:text-dark-text text-black text-center">
              Here are some resources for students and parents to help them
              navigate the world of STEM education.
            </p>
          </div>
        </FadeInSection>

        <div className="px-4 mx-auto w-5/6 xl:w-3/5">
          <FadeInSection distance={FadeInType.SHORT}>
            <div className="relative z-10 mx-auto max-w-7xl">
              <h2
                className={
                  "font-bold tracking-tight dark:text-white text-black text-2xl sm:text-3xl lg:text-4xl "
                }
              >
                Grades K-6
              </h2>
            </div>
          </FadeInSection>
          {YoungResources.map((resource, index) => (
            <FadeInSection key={index} distance={FadeInType.SHORT}>
              <div className="flex flex-col p-4 my-6 dark:bg-white/10 bg-gray-50 dark:text-white/90 text-gray-900 rounded-lg shadow-md border-black/10 border-1">
                <a
                  href={resource.href}
                  className="text-2xl font-semibold hover:underline dark:text-white text-black"
                >
                  {resource.title}
                </a>
                <p className="mt-2 dark:text-dark-text text-black/60">
                  {resource.description}
                </p>
              </div>
            </FadeInSection>
          ))}
          <FadeInSection distance={FadeInType.SHORT}>
            <div className="relative z-10 mx-auto max-w-7xl">
              <h2
                className={
                  "font-bold tracking-tight dark:text-white text-black text-2xl sm:text-3xl lg:text-4xl "
                }
              >
                Grades 7-12
              </h2>
            </div>
          </FadeInSection>
          {OldResources.map((resource, index) => (
            <FadeInSection key={index} distance={FadeInType.SHORT}>
              <div className="flex flex-col p-4 my-6 dark:bg-white/10 bg-gray-50 dark:text-white/90 text-gray-900 rounded-lg shadow-md border-black/10 border-1">
                <a
                  href={resource.href}
                  className="text-2xl font-semibold hover:underline"
                >
                  {resource.title}
                </a>
                <p className="mt-2 dark:text-dark-text text-black/60">
                  {resource.description}
                </p>
              </div>
            </FadeInSection>
          ))}
        </div>
        <div className="absolute top-0 right-0 -z-10">
          <svg
            width="1200"
            height="900"
            viewBox="0 0 1100 900"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" filter="url(#filter1)">
              <rect
                x="300"
                y="-3.65"
                width="629.62"
                height="757"
                transform="rotate(-40.44 463.78 -125.739)"
                fill="url(#grad1)"
              ></rect>
            </g>
            <defs>
              <filter
                id="filter1"
                x="0.0878906"
                y="-776.711"
                width="1726.24"
                height="1876.4"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImage"></feFlood>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImage"
                  result="shape"
                ></feBlend>
                <feGaussianBlur stdDeviation="225"></feGaussianBlur>
              </filter>
              <linearGradient
                id="grad1"
                x1="420.6"
                y1="60.5"
                x2="960.732"
                y2="623.2"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ABBCFF"></stop>
                <stop offset="0.912" stopColor="#4A6CF7"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="absolute bottom-500 left-0 -z-10">
          <svg
            width="1460"
            height="500"
            viewBox="0 0 1460 500"
            fill="none"
            className="overflow-visible"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" filter="url(#filter2)">
              <rect y="460" width="1020" height="250" fill="url(#grad2)"></rect>
            </g>
            <defs>
              <filter
                id="filter2"
                x="-440"
                y="10"
                width="2000"
                height="1050"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImage"></feFlood>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImage"
                  result="shape"
                ></feBlend>
                <feGaussianBlur stdDeviation="225"></feGaussianBlur>
              </filter>
              <linearGradient
                id="grad2"
                x1="-94.8"
                y1="510.634"
                x2="-63.3028465"
                y2="810.234"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ABBCFF"></stop>
                <stop offset="0.8453" stopColor="#4A6CF7"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="absolute bottom-0 left-0 -z-10">
          <svg
            width="1460"
            height="500"
            viewBox="0 0 1460 500"
            fill="none"
            className="overflow-visible"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" filter="url(#filter2)">
              <rect y="460" width="1020" height="250" fill="url(#grad2)"></rect>
            </g>
            <defs>
              <filter
                id="filter2"
                x="-440"
                y="10"
                width="2000"
                height="1050"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImage"></feFlood>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImage"
                  result="shape"
                ></feBlend>
                <feGaussianBlur stdDeviation="225"></feGaussianBlur>
              </filter>
              <linearGradient
                id="grad2"
                x1="-94.8"
                y1="510.634"
                x2="-63.3028465"
                y2="810.234"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ABBCFF"></stop>
                <stop offset="0.8453" stopColor="#4A6CF7"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </section>
      <Footer />
    </div>
  );
}
